define('views/blocks/CartProductOfferedView',['jquery',
        'underscore',
        'backbone',
        'app',
        'SubView',
        'template!blocks/cart/product-offered'
       ],
    function ($,
              _,
              Backbone,
              app,
              SubView,
              productOfferedTemplate
              ) {

        return Backbone.View.extend(SubView).extend({

            events:{
                'click':'onClick',
            },

            initialize: function () {

                var view = this;
                view.subviews = [];
                view.listenTo(app.getCart(),'change:favorite_product_offored_true_id change:favorite_product_offored',view.render);
                view.render();
            },

            render: function () {

                var view = this,
                    cart = app.getCart(),
                    label = app.t('Choisissez votre produit préféré offert','Cart'),
                    html = productOfferedTemplate({
                        cart:cart,
                        label:label,
                    });

                view.$el.html(html);
                view.delegateEvents();
            },

            onClick:function(){
                app.getCart().reopenFreeProductChoice();
            }
        });
    });
